module.exports = __webpack_public_path__ + "img/custom-dashboard.7410cdc3.svg";